import { Component, Input, OnInit } from '@angular/core';

//import { AlertsCountService } from '../../services/alerts-count.service';
import { AlertsService } from "../../services/alerts.service";

@Component({
  selector: 'gn-alert-count',
  templateUrl: './alert-count.component.html',
  styleUrls: ['./alert-count.component.scss']

})
export class AlertCountComponent implements OnInit {
  @Input() domain: string;
  @Input() count: number;

  constructor(public alertsService: AlertsService) {
  }
  ngOnInit(): void {
    // const alertQuery: IAlertsQueryParams = {
    //   page: 0,
    //   sortedfield: 'createdDate',
    //   sortorder: 'desc',
    //   readcount: 0
    // };
    // this.alertsService.getAlerts(this.domain, alertQuery)
  }

}
